<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <WalletTabs></WalletTabs>
      <section ref="content" id="content" class="section subnav no-vpadding">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <div class="columns is-mobile">
              <div class="column">
                  <input
                      v-model="fromDT"
                      :disabled="loading"
                      type="datetime-local"
                      class="input is-small" />
              </div>
              <div class="column">
                  <input
                      v-model="toDT"
                      :disabled="loading"
                      type="datetime-local"
                      class="input is-small" />
              </div>
              <div class="column is-narrow">
                  <button
                      @click="loadTransactions"
                      :disabled="loading"
                      class="button is-info is-small">
                      Search
                  </button>
              </div>
          </div>
          <h4 v-if="!transactions.length" class="title is-size-4 has-text-centered">{{ $t("NoWalletTransactions") }}</h4>
          <table v-if="transactions.length" class="table is-bordered is-fullwidth is-size-7">
              <thead>
                  <tr>
                      <th>{{ $t("Date") }}</th>
                      <th>{{ $t("Amount") }}</th>
                  </tr>
              </thead>
              <tbody>
                  <template v-for="transaction in transactions">
                    <tr :key="transaction.transactionID" class="thick-border-top">
                        <td>{{ transaction.date }}</td>
                        <td>{{ transaction.amount }}</td>
                    </tr>
                    <tr :key="`${transaction.transactionID}-description`">
                        <td colspan="3"><i v-html="transaction.description"></i></td>
                    </tr>
                  </template>
              </tbody>
          </table>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import WalletTabs from "@/components/WalletTabs.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "WalletTransactions",
  components: {
    Header,
    WalletTabs,
    Notification,
    NavigationTabs,
    Spinner
  },
  mounted: async function()
  {
    const toDT = new Date();
    const fromDT = new Date(toDT);
    fromDT.setHours(fromDT.getHours() - 1);

    this.fromDT = this.formatDateTimeInput(fromDT);
    this.toDT = this.formatDateTimeInput(toDT);

    await this.loadTransactions();
  },
  methods:
  {
    loadTransactions: async function()
    {
      try
      {
        this.loading = true;
        this.transactions = [];
        const response = await this.$http.get(`/Transactions`,
        {
            params:
            {
                fromDT: new Date(this.fromDT).toISOString(),
                toDT: new Date(this.toDT).toISOString()
            }
        });

        response.data.transactions.forEach(transaction =>
        {
            let amount = (transaction.amount * this.user.wallet.currency.exchangeRate).toFixed(this.user.wallet.currency.roundToDP);

            if(this.user.wallet.currency.isPrefix)
            {
                amount = this.user.wallet.currency.symbol + amount;
            }

            else
            {
                amount += " " + this.user.wallet.currency.symbol;
            }

            this.transactions.push(
            {
                transactionID: transaction.transactionID,
                date: new Date(transaction.transactionDate).toLocaleString(),
                amount,
                description: transaction.description
            });
        });
      }

      catch(error)
      {
        this.$refs.content.scrollTo(0, 0);
        
        if(error.response)
        {
            this.notification =
            {
                show: true,
                className: "is-danger",
                text: error.response.data.message
            }
        }
        
        else
        {
            this.notification =
            {
                show: true,
                className: "is-danger",
                text: this.$t("Error")
            }
        }
    }

    this.loading = false;
    },
    formatDateTimeInput: function(date)
    {
        const pad = value => value.toString().padStart(2, "0");

        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    }
  },
  data () {
      return {
          transactions: [],
          fromDT: null,
          toDT: null
      }
  }
};
</script>
